/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type StorefrontFeaturedSection_user$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type StorefrontHome_user$ref: FragmentReference;
export type StorefrontHome_user = {|
  +$fragmentRefs: StorefrontFeaturedSection_user$ref,
  +$refType: StorefrontHome_user$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "StorefrontHome_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "StorefrontFeaturedSection_user",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'c8f3973dfb191c16a7a06932ffba73d2';
module.exports = node;
